<template>
  <div class="g-sidenav-show" style="background-color: #f0f6ff;">
    <div class="min-height-300 bg-dark position-absolute w-100"></div>
    <HeaderMenu />
    <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
      <!-- Notificaciones -->
      <div class="position-fixed top-0 end-0 p-3" style="z-index: 1100">
        <div v-for="(notification, index) in notifications" :key="index"
          :class="['alert', notification.class, 'alert-dismissible fade show']" role="alert">
          {{ notification.message }}
          <button type="button" class="btn-close" @click="closeNotification(index)"></button>
        </div>
      </div>

      <div class="container-fluid py-4 pt-6" style="min-height: 100vh;">
        <div class="row">
          <div class="col-12">
            <div class="card mb-4">
              <div class="card-header pb-0">
                <h5 class="mb-0">
                  <i class="fas fa-chart-line me-2"></i>Panel de Consulta - Aprobación Avanzada
                </h5>
              </div>
              <div class="card-body">
                <!-- Selector de esquema y KPIs (siempre visible el selector) -->
                <div class="row mb-4">
                  <div class="col-md-2">
                    <div class="card border h-100">
                      <div class="card-body d-flex flex-column justify-content-center">
                        <h6 class="text-muted mb-2">Esquema</h6>
                        <select class="form-select form-select-sm" v-model="esquemaSeleccionadoId" @change="cargarDatos">
                          <option value="">Selecciona...</option>
                          <option v-for="esq in esquemasConAprobacionAvanzada" :key="esq.id" :value="esq.id">
                            {{ esq.nombre }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <template v-if="datosPanel">
                    <div class="col-md-2">
                      <div class="card border h-100">
                        <div class="card-body text-center">
                          <h6 class="text-muted mb-2">Total Secciones</h6>
                          <h3 class="mb-0">{{ datosPanel.departamentos.length }}</h3>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="card border h-100">
                        <div class="card-body text-center">
                          <h6 class="text-muted mb-2">Aprobadas Automáticamente</h6>
                          <h3 class="mb-0 text-success">
                            {{ totalAprobadasAutomaticamente }}
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="card border h-100">
                        <div class="card-body text-center">
                          <h6 class="text-muted mb-2">Pendientes por importe</h6>
                          <h3 class="mb-0 text-warning">
                            {{ totalPendientesTipo1 }}
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="card border h-100">
                        <div class="card-body text-center">
                          <h6 class="text-muted mb-2">Pendientes por acumulado</h6>
                          <h3 class="mb-0 text-warning">
                            {{ totalPendientesTipo2 }}
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="card border h-100">
                        <div class="card-body text-center">
                          <h6 class="text-muted mb-2">Pendientes por rango</h6>
                          <h3 class="mb-0 text-danger">
                            {{ totalPendientesTipo3 }}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>

                <!-- Spinner de carga -->
                <div v-if="cargando" class="text-center py-5">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Cargando...</span>
                  </div>
                </div>

                <!-- Mensaje cuando no hay esquema seleccionado -->
                <div v-else-if="!esquemaSeleccionadoId" class="text-center py-5">
                  <i class="fas fa-arrow-up fa-3x text-muted mb-3"></i>
                  <p class="text-muted">Selecciona un esquema con aprobación avanzada para ver el panel de consulta</p>
                </div>

                <!-- Error -->
                <div v-else-if="error" class="alert alert-danger">
                  {{ error }}
                </div>

                <!-- Datos del panel -->
                <div v-else-if="datosPanel">
                  <!-- Buscador de secciones (solo si hay más de 10) -->
                  <div v-if="datosPanel.departamentos && datosPanel.departamentos.length > 10" class="row mb-3">
                    <div class="col-md-4">
                      <div class="input-group">
                        <span class="input-group-text"><i class="fas fa-search"></i></span>
                        <input 
                          type="text" 
                          class="form-control" 
                          placeholder="Buscar sección por nombre..." 
                          v-model="busquedaSeccion"
                        />
                        <span 
                          v-if="busquedaSeccion" 
                          class="input-group-text bg-white" 
                          style="cursor: pointer;"
                          @click="busquedaSeccion = ''"
                        >
                          <i class="fas fa-times"></i>
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- Departamentos -->
                  <div class="accordion mb-4" id="accordionDepartamentos">
                    <div v-for="(dept, index) in departamentosFiltrados" :key="dept.departamento_id" class="accordion-item border">
                      <h2 class="accordion-header bg-light" :id="'heading' + dept.departamento_id">
                        <button class="accordion-button bg-light" :class="{ collapsed: index !== 0 }" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse' + dept.departamento_id" :aria-expanded="index === 0 ? 'true' : 'false'" :aria-controls="'collapse' + dept.departamento_id">
                          <i class="fas fa-building me-2"></i>{{ dept.departamento_nombre }}
                        </button>
                      </h2>
                      <div :id="'collapse' + dept.departamento_id" class="accordion-collapse collapse" :class="{ show: index === 0 }" :aria-labelledby="'heading' + dept.departamento_id" data-bs-parent="#accordionDepartamentos">
                        <div class="accordion-body">
                      <!-- Resumen del departamento -->
                      <div class="row mb-3">
                        <div class="col-md-3">
                          <div class="d-flex align-items-center">
                            <i class="fas fa-check-circle text-success me-2"></i>
                            <div>
                              <small class="text-muted d-block">Aprobadas automáticamente</small>
                              <strong>{{ dept.facturas_aprobadas_automaticamente }}</strong>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="d-flex align-items-center">
                            <i class="fas fa-clock text-warning me-2"></i>
                            <div>
                              <small class="text-muted d-block">Pendientes por importe</small>
                              <strong>{{ dept.facturas_pendientes.tipo1_usuario }}</strong>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="d-flex align-items-center">
                            <i class="fas fa-clock text-warning me-2"></i>
                            <div>
                              <small class="text-muted d-block">Pendientes por acumulado</small>
                              <strong>{{ dept.facturas_pendientes.tipo2_usuario }}</strong>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="d-flex align-items-center">
                            <i class="fas fa-exclamation-triangle text-danger me-2"></i>
                            <div>
                              <small class="text-muted d-block">Pendientes por rango</small>
                              <strong>{{ dept.facturas_pendientes.tipo3 }}</strong>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Configuración de reglas y Facturas por usuario -->
                      <div v-if="dept.configuracion_regla" class="mb-4">
                        <h6 class="mb-3"><i class="fas fa-cog me-2"></i>Configuración de Reglas y Facturas por Usuario</h6>
                        <div class="row g-3 mb-3">
                          <!-- Tipo 1 -->
                          <div v-if="dept.configuracion_regla.tipo1" class="col-md-6">
                            <div class="card border border-info h-100">
                              <div class="card-body p-3">
                                <div class="d-flex align-items-start">
                                  <div class="flex-grow-1">
                                    <p class="mb-1"><strong>Aprobación automática por importe</strong></p>
                                    <p class="mb-1 text-muted small">{{ dept.configuracion_regla.tipo1.descripcion }}</p>
                                    <div class="d-flex flex-column gap-2 mt-2">
                                      <small><strong>Límite:</strong> {{ formatDecimal(dept.configuracion_regla.tipo1.importe_max) }} €</small>
                                      <small v-if="dept.configuracion_regla.tipo1.usuario_aprobador_nombre">
                                        <strong>Aprobador:</strong> {{ dept.configuracion_regla.tipo1.usuario_aprobador_nombre }}
                                      </small>
                                    </div>
                                    <div class="mt-3 pt-3 border-top">
                                      <small class="text-muted">
                                        <strong>Pendientes:</strong> {{ getTotalesPorTipo(dept, 'tipo1').pendientes }} | 
                                        <strong>Aprobadas:</strong> {{ getTotalesPorTipo(dept, 'tipo1').aprobadas }} | 
                                        <strong>Total:</strong> {{ getTotalesPorTipo(dept, 'tipo1').total }}
                                      </small>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Tipo 2 -->
                          <div v-if="dept.configuracion_regla.tipo2" class="col-md-6">
                            <div class="card border border-primary h-100">
                              <div class="card-body p-3">
                                <div class="d-flex align-items-start">
                                  <div class="flex-grow-1">
                                    <p class="mb-1"><strong>Aprobación por acumulado</strong></p>
                                    <p class="mb-1 text-muted small">{{ dept.configuracion_regla.tipo2.descripcion }}</p>
                                    <div class="d-flex flex-column gap-2 mt-2">
                                      <small><strong>Límite acumulado:</strong> {{ formatDecimal(dept.configuracion_regla.tipo2.importe_max_acumulado) }} €</small>
                                      <small><strong>Período:</strong> {{ dept.configuracion_regla.tipo2.periodo_texto }}</small>
                                      <small v-if="dept.configuracion_regla.tipo2.usuario_aprobador_nombre">
                                        <strong>Aprobador:</strong> {{ dept.configuracion_regla.tipo2.usuario_aprobador_nombre }}
                                      </small>
                                    </div>
                                    <div class="mt-3 pt-3 border-top">
                                      <small class="text-muted">
                                        <strong>Pendientes:</strong> {{ getTotalesPorTipo(dept, 'tipo2').pendientes }} | 
                                        <strong>Aprobadas:</strong> {{ getTotalesPorTipo(dept, 'tipo2').aprobadas }} | 
                                        <strong>Total:</strong> {{ getTotalesPorTipo(dept, 'tipo2').total }}
                                      </small>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Tipo 3 -->
                        <div v-if="dept.configuracion_regla.tipo3 && dept.configuracion_regla.tipo3.length > 0" class="row">
                          <div class="col-md-12">
                            <div class="card border border-secondary">
                              <div class="card-body p-3">
                                <div class="d-flex align-items-start mb-3">
                                  <div class="flex-grow-1">
                                    <p class="mb-0"><strong>Aprobación por rangos</strong></p>
                                    <small v-if="dept.configuracion_regla.tipo3.some(r => r.aprobacion_acumulada)" class="text-warning">
                                      <i class="fas fa-info-circle me-1"></i>Aprobación acumulada activada
                                    </small>
                                  </div>
                                </div>
                                <div class="table-responsive">
                                  <table class="table table-sm table-bordered mb-0">
                                    <thead class="table-light">
                                      <tr>
                                        <th style="width: 100px">Modo</th>
                                        <th>Descripción</th>
                                        <th class="text-center">Pendientes</th>
                                        <th class="text-center">Aprobadas</th>
                                        <th class="text-center">Total</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="rango in dept.configuracion_regla.tipo3" :key="rango.rango_id">
                                        <td class="text-center">
                                          <span v-if="rango.aprobacion_acumulada" class="badge bg-warning">Acumulada</span>
                                          <span v-else class="badge bg-light text-dark">Individual</span>
                                        </td>
                                        <td>
                                          <small class="text-muted" v-html="formatearDescripcionConUsuario(rango.descripcion, rango.usuario_aprobador_nombre)"></small>
                                        </td>
                                        <td class="text-center">
                                          <span v-if="getTotalesPorRango(dept, rango.rango_id).pendientes > 0" class="badge bg-warning">
                                            {{ getTotalesPorRango(dept, rango.rango_id).pendientes }}
                                          </span>
                                          <span v-else class="text-muted">0</span>
                                        </td>
                                        <td class="text-center">
                                          <span class="badge bg-success">{{ getTotalesPorRango(dept, rango.rango_id).aprobadas }}</span>
                                        </td>
                                        <td class="text-center">
                                          <strong>{{ getTotalesPorRango(dept, rango.rango_id).total }}</strong>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Acumulados por períodos -->
                      <div v-if="dept.acumulados_periodos && dept.acumulados_periodos.length > 0" class="mb-4">
                        <h6 class="mb-3"><i class="fas fa-chart-area me-2"></i>Acumulados por Períodos</h6>
                        <div class="table-responsive">
                          <table class="table table-sm table-bordered">
                            <thead class="table-light">
                              <tr>
                                <th>Período</th>
                                <th>Fechas</th>
                                <th class="text-center">Documentos</th>
                                <th class="text-end">Acumulado</th>
                                <th class="text-center">Variación</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(periodo, index) in dept.acumulados_periodos" :key="periodo.periodo">
                                <td><strong>{{ periodo.periodo }}</strong></td>
                                <td>
                                  <small class="text-muted">{{ formatDate(periodo.fecha_inicio) }} - {{ formatDate(periodo.fecha_fin) }}</small>
                                </td>
                                <td class="text-center">{{ periodo.contador_documentos || 0 }}</td>
                                <td class="text-end">{{ formatCurrency(periodo.acumulado) }}</td>
                                <td class="text-center">
                                  <span :class="getVariacionClass(calcularVariacion(dept.acumulados_periodos, index))">
                                    {{ calcularVariacion(dept.acumulados_periodos, index) }}
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Mensaje si no hay departamentos -->
                  <div v-if="datosPanel.departamentos.length === 0" class="text-center py-5 text-muted">
                    <i class="fas fa-info-circle me-2"></i>No hay departamentos con reglas configuradas
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import HeaderMenu from '@/components/HeaderMenu.vue';
import { ref, computed, onMounted } from 'vue';
import axiosInstance from '@/axios';

export default {
  name: 'PanelConsultaAprobacionView',
  components: { HeaderMenu },
  setup() {
    const notifications = ref([]);
    const esquemas = ref([]);
    const esquemaSeleccionadoId = ref('');
    const datosPanel = ref(null);
    const cargando = ref(false);
    const error = ref(null);
    const busquedaSeccion = ref('');

    const closeNotification = (index) => notifications.value.splice(index, 1);
    const showNotification = (message, type = 'alert-info') => {
      notifications.value.push({ message, class: type });
      setTimeout(() => notifications.value.shift(), 5000);
    };

    const esquemasConAprobacionAvanzada = computed(() => {
      return esquemas.value.filter(e => e.aprobacion_avanzada);
    });

    const departamentosFiltrados = computed(() => {
      if (!datosPanel.value || !datosPanel.value.departamentos) {
        return [];
      }
      if (!busquedaSeccion.value.trim()) {
        return datosPanel.value.departamentos;
      }
      const busqueda = busquedaSeccion.value.toLowerCase().trim();
      return datosPanel.value.departamentos.filter(dept => 
        dept.departamento_nombre.toLowerCase().includes(busqueda)
      );
    });

    const totalAprobadasAutomaticamente = computed(() => {
      if (!datosPanel.value) return 0;
      return datosPanel.value.departamentos.reduce((sum, dept) => 
        sum + (dept.facturas_aprobadas_automaticamente || 0), 0
      );
    });

    const totalPendientesTipo1 = computed(() => {
      if (!datosPanel.value) return 0;
      return datosPanel.value.departamentos.reduce((sum, dept) => 
        sum + (dept.facturas_pendientes?.tipo1_usuario || 0), 0
      );
    });

    const totalPendientesTipo2 = computed(() => {
      if (!datosPanel.value) return 0;
      return datosPanel.value.departamentos.reduce((sum, dept) => 
        sum + (dept.facturas_pendientes?.tipo2_usuario || 0), 0
      );
    });

    const totalPendientesTipo3 = computed(() => {
      if (!datosPanel.value) return 0;
      return datosPanel.value.departamentos.reduce((sum, dept) => 
        sum + (dept.facturas_pendientes?.tipo3 || 0), 0
      );
    });

    const cargarEsquemas = async () => {
      try {
        const response = await axiosInstance.get('/api/esquemas');
        esquemas.value = response.data.esquemas || response.data;
        esquemas.value.forEach(e => {
          e.aprobacion_avanzada = !!e.aprobacion_avanzada;
        });
      } catch (error) {
        console.error('Error cargando esquemas:', error);
        showNotification('Error al cargar esquemas', 'alert-danger');
      }
    };

    const cargarDatos = async () => {
      if (!esquemaSeleccionadoId.value) {
        datosPanel.value = null;
        error.value = null;
        return;
      }

      cargando.value = true;
      error.value = null;
      
      try {
        const response = await axiosInstance.get(`/api/aprobacionAvanzada/panelConsulta/${esquemaSeleccionadoId.value}`, {
          timeout: 600000 // 600 segundos = 600000 milisegundos
        });
        if (response.data.error) {
          error.value = response.data.error;
          datosPanel.value = null;
        } else {
          datosPanel.value = response.data;
        }
      } catch (error) {
        console.error('Error cargando datos del panel:', error);
        error.value = error.response?.data?.error || 'Error al cargar los datos del panel';
        datosPanel.value = null;
      } finally {
        cargando.value = false;
      }
    };

    const formatDecimal = (value) => {
      if (value === null || value === undefined) return '0.00';
      return parseFloat(value).toFixed(2).replace('.', ',');
    };

    const formatCurrency = (value) => {
      if (value === null || value === undefined) return '0,00 €';
      const num = parseFloat(value);
      // Formatear con punto para miles y coma para decimales
      const parts = num.toFixed(2).split('.');
      const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      const decimalPart = parts[1];
      return `${integerPart},${decimalPart} €`;
    };

    const formatDate = (dateString) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('es-ES', { 
        year: 'numeric', 
        month: '2-digit', 
        day: '2-digit' 
      });
    };

    const getTotalesPorTipo = (dept, tipo) => {
      if (!dept.facturas_por_usuario) {
        return { pendientes: 0, aprobadas: 0, total: 0 };
      }
      const usuarios = dept.facturas_por_usuario.filter(u => u.tipo === tipo);
      const pendientes = usuarios.reduce((sum, u) => sum + (u.pendientes || 0), 0);
      const aprobadas = usuarios.reduce((sum, u) => sum + (u.aprobadas || 0), 0);
      return {
        pendientes,
        aprobadas,
        total: pendientes + aprobadas
      };
    };

    const getTotalesPorRango = (dept, rangoId) => {
      if (!dept.facturas_por_usuario || !dept.configuracion_regla?.tipo3) {
        return { pendientes: 0, aprobadas: 0, total: 0 };
      }
      // Buscar el rango en la configuración para obtener el usuario_aprobador_id
      const rango = dept.configuracion_regla.tipo3.find(r => r.rango_id === rangoId);
      if (!rango || !rango.usuario_aprobador_id) {
        return { pendientes: 0, aprobadas: 0, total: 0 };
      }
      // Buscar usuarios de tipo3 que correspondan a este usuario aprobador
      const usuarios = dept.facturas_por_usuario.filter(u => 
        u.tipo === 'tipo3' && u.usuario_aprobador_id === rango.usuario_aprobador_id
      );
      const pendientes = usuarios.reduce((sum, u) => sum + (u.pendientes || 0), 0);
      const aprobadas = usuarios.reduce((sum, u) => sum + (u.aprobadas || 0), 0);
      return {
        pendientes,
        aprobadas,
        total: pendientes + aprobadas
      };
    };

    const formatearDescripcionConUsuario = (descripcion, nombreUsuario) => {
      if (!descripcion || !nombreUsuario) {
        return descripcion || '';
      }
      // Reemplazar el nombre del usuario en la descripción con una versión en negrita
      // La descripción tiene el formato "Requiere aprobación de XXX si el importe es ≥ YYY€"
      const nombreEnNegrita = `<strong>${nombreUsuario}</strong>`;
      // Buscar y reemplazar el nombre del usuario en la descripción
      return descripcion.replace(nombreUsuario, nombreEnNegrita);
    };

    const calcularVariacion = (periodos, index) => {
      // Los períodos están ordenados de más reciente a más antiguo
      // La última fila (más antigua) no tiene período siguiente para comparar
      if (!periodos || index === periodos.length - 1) {
        return '-';
      }
      const periodoActual = periodos[index]; // Más reciente
      const periodoSiguiente = periodos[index + 1]; // Más antiguo (anterior en el tiempo)
      
      if (!periodoActual || !periodoSiguiente || !periodoSiguiente.acumulado || periodoSiguiente.acumulado === 0) {
        return '-';
      }
      
      // Calcular variación del período actual (más reciente) respecto al siguiente (más antiguo)
      // Ejemplo: Diciembre (100) vs Noviembre (50) = ((100 - 50) / 50) * 100 = +100%
      const variacion = ((periodoActual.acumulado - periodoSiguiente.acumulado) / periodoSiguiente.acumulado) * 100;
      const signo = variacion >= 0 ? '+' : '';
      return `${signo}${variacion.toFixed(2)}%`;
    };

    const getVariacionClass = (variacion) => {
      if (variacion === '-' || !variacion) {
        return 'text-muted';
      }
      if (variacion.startsWith('+')) {
        return 'text-success fw-bold';
      }
      return 'text-danger fw-bold';
    };

    onMounted(async () => {
      await cargarEsquemas();
    });

    return {
      notifications,
      closeNotification,
      esquemas,
      esquemasConAprobacionAvanzada,
      esquemaSeleccionadoId,
      datosPanel,
      cargando,
      error,
      busquedaSeccion,
      departamentosFiltrados,
      cargarDatos,
      totalAprobadasAutomaticamente,
      totalPendientesTipo1,
      totalPendientesTipo2,
      totalPendientesTipo3,
      formatDecimal,
      formatCurrency,
      formatDate,
      getTotalesPorTipo,
      getTotalesPorRango,
      formatearDescripcionConUsuario,
      calcularVariacion,
      getVariacionClass
    };
  }
};
</script>

<style scoped>
.card {
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.badge {
  font-weight: 500;
  padding: 0.35em 0.65em;
}
</style>

